<template>
  <IndexTab :product="product" />
</template>

<script lang="ts" setup>
import IndexTab from '~/components/price-assessments/IndexTab.vue'
import type { TProduct } from '~/src/types/product.ts'
import { BLACK_MASS, MARKET } from '~/constants/services/constants'

/*-------------------------------------
  Meta
-------------------------------------*/
definePageMeta({ isTab: true })

const { getSeoInfo } = useSeo()
const seo = getSeoInfo({
  title: `${MARKET.name}: ${BLACK_MASS.name} Prices`,
  description: `Access real-time and historic black mass prices from Benchmark, with expert supply/demand analysis and market commentary.`,
})
useHead(seo)
/*-------------------------------------
  Props & Refs
-------------------------------------*/
defineProps<{
  product: TProduct
}>()
</script>
